import * as ngCore from '@angular/core'
import * as ngRouter from '@angular/router'
import * as ds from '@attain-apps/fe/web/main/lib/design'

import * as state from '../../../../../../../../../state'
import * as sections from '../../sections'

@ngCore.Component({
  imports: [
    ngRouter.RouterLink,
    ds.layout.page.Component,
    sections.header.Component,
    sections.grid.Component,
    ds.loader.Component,
  ],
  selector: 'atn-mosaic-tabbed-content',
  styleUrl: './component.scss',
  templateUrl: './component.html',
})
export class Component {
  /** @see {@link state.mosaic.endUser.currentRendering.Feature } */
  public readonly currentRendering = ngCore.inject(
    state.mosaic.endUser.currentRendering.Feature,
  )
}
